import { useEffect, useState } from "react";
import { Row, Col } from "react-grid-system";

import styled from "styled-components";

import { AiOutlineDelete } from "react-icons/ai";
import { IoIosArrowBack } from "react-icons/io";
import { BiFoodMenu } from "react-icons/bi";

import { StyledColor } from "../../../interface/index";
import colors from "../../../assets/colors/colors";
import ModalItems from "./ModalItems";
import Loader from "../../utils/Loader";

interface Props {
  closeModal: () => {};
  createSection: any;
  type: string;
  data: any;
  editSection: any;
  deleteSection: any;
  loader: boolean;
}

export default function ModalCreateSection(props: Props) {
  const { data, type } = props;

  const [form, setForm] = useState<any>({
    name: "",
    description: "",
  });

  const [modalitems, setModalItems] = useState<any>(false);
  const [dataitem, setDataItem] = useState<any>(null);

  useEffect(() => {
    if (type === "editar") hanldeDataEdit();
  }, []);

  // data edit
  const hanldeDataEdit = () => {
    setForm({
      name: data.name,
      description: data.description,
    });
  };

  const closeFullScreen = () => {
    props.closeModal();
  };

  const onChange = (e: any) => {
    const value = e.target.value;
    const index = e.target.id;
    form[index] = value;
    setForm({
      ...form,
    });
  };

  const handleCreate = () => {
    if (type === "crear") {
      props.createSection(form);
    }
    if (type === "editar") {
      props.editSection({ ...data, ...form });
    }
  };

  const handleDelete = () => {
    const con = window.confirm(
      "Estas seguro que quieres eliminar esta sesión con todo su menu.🙉?"
    );
    if (con) {
      props.deleteSection(data);
      // eliminar
    }
  };

  const handleOpenModalItems = () => {
    let open = !modalitems;
    setDataItem(props.data);
    setModalItems(open);
  };
  return (
    <Content color={colors}>
      <header>
        <Row align="center">
          <Col xs={2}>
            <button onClick={() => closeFullScreen()}>
              <IoIosArrowBack />
            </button>
          </Col>
          <Col>
            <h2 className="px-2 pt-1">
              {props.type === "editar" && "Editar"}{" "}
              {props.type === "crear" && "Crear"} categoría
            </h2>
          </Col>
        </Row>
      </header>
      <div className="main">
        <div className="create">
          <div>
            <label>Nombre de la categoría</label>
            <input
              type="text"
              placeholder="Nombre de la categoría"
              className="form-control"
              id="name"
              onChange={onChange}
              value={form.name}
            />
          </div>
        </div>
      </div>
      {props.type === "editar" && (
        <div className="w-100 text-center">
          <button
            className="btn btn-primary px-4"
            onClick={() => handleOpenModalItems()}
          >
            Ver Menu{" "}
            <BiFoodMenu style={{ marginTop: "-2px", fontSize: "1.4em" }} />
          </button>
        </div>
      )}
      <hr />
      {!props.loader && (
        <>
          <div className="w-100 my-4 text-center">
            <div className="row align-items-center justify-content-center">
              <div className="col-4">
                <button
                  className="btn btn-secondary d-block w-100"
                  onClick={() => closeFullScreen()}
                >
                  Cancelar
                </button>
              </div>
              <div className="col-4">
                <button
                  className="btn btn-success d-block w-100"
                  onClick={() => handleCreate()}
                >
                  {props.type === "editar" && "Editar"}{" "}
                  {props.type === "crear" && "Crear"}{" "}
                </button>
              </div>
            </div>
          </div>
          {props.type === "editar" && (
            <div className="w-100 text-center">
              <button
                className="btn btn-secondary text-danger"
                onClick={() => handleDelete()}
              >
                Eliminar sesión{" "}
                <AiOutlineDelete
                  style={{ marginTop: "-2px", fontSize: "1.4em" }}
                />
              </button>
            </div>
          )}
        </>
      )}

      {props.loader && (
        <div className="w-100 text-center">
          <Loader color="#3498db" />
        </div>
      )}

      {modalitems && (
        <ModalItems closeModal={handleOpenModalItems} data={dataitem} />
      )}
    </Content>
  );
}

const Content = styled.div<StyledColor>`
  width: 100%;
  height: 100vh;
  background: white;
  position: fixed;
  top: 0;
  left: 0;
  header {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 10000;
    padding: 1em 0;
    background: white;
    border-bottom: 1px solid #ecf0f1;
    color: #2c3e50;
    button {
      border: none;
      background: white;
      padding: 0.8em 1em;
      box-shadow: 0px 0px 10px #0000012f;
      border-radius: 6px;
      color: #2c3e50;
      svg {
        font-size: 1.5em;
        margin-top: -5px;
      }
    }
  }
  .main {
    width: 100%;
    min-height: 10vh;
    padding: 1em;
    margin-top: 5em;
    .create {
      div {
        padding: 0.5em;
      }
    }
  }

  label {
    font-size: 1em;
    font-weight: 600;
  }
  input,
  textarea {
    display: block;
    font-size: 1em;
    border: 2px solid ${(props) => props.color.white01};
    &:focus {
      border: 2px solid ${(props) => props.color.blue};
    }
  }
`;
